// src/components/common/TableCell.jsx
import React from "react";
import TinyMCEpreview from "../../const/TinyMCEpreview";

const TableCell = ({
  label,
  editing,
  rich = false,
  value,
  input,
  labelBg = "bg-gray-100",
  valueBg = "bg-white",
  labelWidth = "80px", // ← 기본 라벨 폭
  textCenter = false,
  colSpan = 1,
}) => {
  let content;

  if (editing) {
    content = input;
  } else if (rich) {
    // 🔥 rich 모드
    if (typeof value === "string") {
      content = <TinyMCEpreview html={value} />;
    } else {
      content = value;
    }
  } else {
    content = <span>{value ?? "-"}</span>;
  }

  return (
    <>
      {/* LABEL CELL */}
      <td
        className={`tbl-label-bg px-3 py-2 font-medium ${labelBg} ${
          textCenter ? "text-center" : ""
        }`}
        style={{ width: labelWidth, whiteSpace: "nowrap" }} // ⭐ label 고정폭 & 줄바꿈 금지
      >
        <div className="text-body">{label}</div>
      </td>

      {/* VALUE CELL */}
      <td
        className={`tbl-value-bg px-3 py-2 ${valueBg}`}
        colSpan={colSpan}
        style={{ width: "auto" }} // ⭐ table-fixed 환경에서 균등 분배 핵심
      >
        <div className="items-center min-w-0">
          {/* min-w-0 → flex 내부에서 텍스트 줄바꿈 방지 + 공간 균등 분배 */}
          <div className="text-body whitespace-pre-wrap break-words">{content}</div>

        </div>
      </td>
    </>
  );
};

export default TableCell;
